<template>
  <v-card flat :style="`height: ${ windowSize.y }px; position: 'relative'`" class="pa-1 product-view" v-resize="onResizeHandler">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pa-0">
      <v-form ref="pickForm" v-on:submit.prevent>
        <v-row>
          <v-col cols="6" class="pb-0 pt-0 font-weight-bold">{{ orderModel.number }}</v-col>
          <v-col cols="6" class="pb-0 pt-0 pr-1 text-right">{{ $t('message.order.send_week') }}: {{ orderModel.sendfrom_warehouse }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0 pl-3 font-weight-bold">{{ orderModel.customer_name || '' }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="8" class="pt-0 pr-0 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scanCode" flat :disabled="isAllPicked" autocomplete="off"
              ref="scanFocus" @change="getRespectiveProductOrder" :loading="productLoading"
            :placeholder="$t('message.order.scanProduct')"></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-1 pb-1 font-weight-bold" v-if="productFound">
            {{ productInfo.productname || '' }}
          </v-col>
          <template v-if="productFound && productInfo.isbatch && (productInfo.producttype === 'product')">
            <v-col cols="7" class="pt-0 pb-0">
              <v-text-field outlined dense hide-details v-model="selectBatch" flat @change="checkTheBatchnumber" autocomplete="off"
              :rules="productInfo.producttype === 'product' ? $_requiredValidation : []" :placeholder="$t('message.product.batch')" ref="batchRef"
              :loading="loadingBatch"></v-text-field>
            </v-col>
            <v-col cols="5" class="pl-0 pt-0 pb-0" v-if="moreLocationsFound">
              <v-text-field outlined dense hide-details v-model="selectedLocation" flat autocomplete="off"
                :rules="productInfo.producttype === 'product' ? $_requiredValidation : []" @change="checkIfLocationValid" :loading="loadingLocation"
                ref="moreLocation" :placeholder="$t('message.product.scanLoc')"></v-text-field>
            </v-col>
          </template>
          <v-col cols="8" class="pt-0 pb-0" v-if="productFound && !productInfo.isbatch && (productInfo.producttype === 'product')">
            <v-text-field outlined dense hide-details v-model="selectedLocation" flat autocomplete="off"
              :rules="$_requiredValidation" @change="checkIfLocationValid" :loading="loadingLocation"
              ref="moreLocation" :placeholder="$t('message.product.scanLoc')"></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="productFound">
          <v-col cols="9" class="pa-1">
            <v-row>
              <v-col cols="3" class="text-center pa-0" @click="decreaseQty">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-text-field outlined dense hide-details type="number" class="text-right" v-model="pickQty"
                  autocomplete="off" ref="qtyRef" :rules="$_qtyValidation" :placeholder="$t('message.product.qty')"></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center pa-0" @click="increaseQty">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" class="pa-1 mt-1">
            <v-btn color="primary" dark small @click="pickQtyOnOrder" :loading="saveLoading">
              {{ $t('message.order.pick') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <!-- TO BE PICKED PRODUCTS -->
    <v-card-text class="pt-0 pb-0 pl-1 mt-2 pickProducts">
      <v-row class="highlight">
        <v-col cols="6" class="pa-0 pl-3 font-weight-bold">{{ $t('message.order.toPick') }}:</v-col>
        <v-col cols="2" class="pa-0 font-weight-bold">{{ $t('message.order.location') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.avail') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in toBePickedProducts" :key="index" class="productRow" @click="updateProductForPicking(product)">
        <v-col cols="6" class="pa-0 pl-3 text-truncate" :title="product.number" :class="{ 'pb-1': (index === toBePickedProducts.length - 1)}">
          <span>{{ product.number }}</span>
          <v-row>
            <v-col cols="12" class="pa-0 pb-1 text-truncate productInfo" :title="product.producttext">{{ product.producttext }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-row v-for="(location, index) in product.locations" :key="`${index}_location`">
            <v-col cols="12" class="pa-0 text-truncate" :title="location.locationname">{{ location.locationname }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">
          {{ product.orderedqty | absoluteNumber }}
        </v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">
          <v-row v-for="(location, index) in product.locations" :key="`${index}_location`">
            <v-col cols="12" class="pa-0 pl-1 text-right text-truncate" :title="location.availableqty">
              {{ location.availableqty | absoluteNumber }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- PICKED PRODUCTS -->
    <v-card-text tabindex="0" class="pt-0 pb-0 pl-1 mt-2 pickProducts">
      <v-row class="highlight">
        <v-col cols="6" class="pa-0 pl-3 font-weight-bold">{{ $t('message.order.picked') }}:</v-col>
        <v-col cols="2" class="pa-0 font-weight-bold">{{ $t('message.order.location') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold">{{ $t('message.order.picked') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in pickedProducts" :key="index" class="productRow">
        <v-col cols="6" class="pa-0 pl-3 text-truncate" :title="product.number" :class="{ 'pb-1': (index === pickedProducts.length - 1)}">
          <span v-if="product.ispackage"><b>{{ product.number }}</b></span>
          <span v-else>{{ product.number }}</span>
          <v-row>
            <v-col cols="12" class="pa-0 pb-1 text-truncate productInfo" :title="product.producttext">{{ product.producttext }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0 text-truncate" :title="product.locationname">{{ product.locationname }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right text-truncate">
          {{ product.orderedqty | absoluteNumber }}
        </v-col>
        <v-col cols="2" class="pa-0 text-right text-truncate" :title="product.qty">{{ product.qty | absoluteNumber }}</v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      scanCode: '',
      windowSize: {
        x: 0,
        y: 0
      },
      productFound: false,
      productInfo: {},
      pickQty: '',
      listOfLocations: [],
      selectedLocation: '',
      selectBatch: '',
      saveLoading: false,
      loadingBatch: false,
      isAllPicked: false,
      moreLocationsFound: false,
      batchLocations: [],
      productLoading: false,
      loadingLocation: false
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.order_id
    this.getMaterialProducts()
    this.getOrderInfo()
    this.onResizeHandler()
    this.focusField('scanFocus')
  },
  computed: {
    toBePickedProducts () {
      return this.listOfProducts && this.listOfProducts.topickproducts ? this.listOfProducts.topickproducts.filter(x => !x.ispackage) : []
    },
    pickedProducts () {
      return this.listOfProducts && this.listOfProducts.pickedproducts ? this.listOfProducts.pickedproducts.filter(x => !x.ispackage) : []
    }
  },
  watch: {
    pickQty (val) {
      let pickedQty = +this.$format.replaceCommaWithDot(this.pickQty || 0)
      let locations = this.listOfLocations
      if (this.selectedLocation) {
        let getOnStockValue = locations.find(x => x.locationname === this.selectedLocation)
        if (getOnStockValue) {
          if (this.productInfo.isbatch && getOnStockValue.batches) {
            let getBatchQty = getOnStockValue.batches
            let getObj = getBatchQty.find(x => x.batchnumber === this.selectBatch)
            if (getObj) {
              if (pickedQty > getObj.onstock) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
                setTimeout(() => {
                  this.pickQty = getObj.onstock
                })
              }
            }
          } else {
            let onstock = getOnStockValue.availableqty
            if (pickedQty > onstock) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
              setTimeout(() => {
                this.pickQty = onstock
              })
            }
          }
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
          setTimeout(() => {
            this.pickQty = ''
            this.selectedLocation = ''
            this.focusField('moreLocation')
          })
        }
      }
      let orderedQty = this.productInfo.orderedqty
      if (pickedQty > orderedQty) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
        setTimeout(() => {
          this.pickQty = orderedQty
        })
      }
    }
  },
  methods: {
    getOrderInfo () {
      let model = {
        'expand': [{
          'select': ['name'],
          'model': 'Customer',
          'on_field': 'id',
          'on_parent_field': 'customerid'
        }],
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'orders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
          }
        })
    },
    getMaterialProducts () {
      this.$api.execute('get', `/ordermaterials/get_materials/${this.orderId}`)
        .then((response) => {
          if (response.data) {
            this.listOfProducts = response.data
            if (this.listOfProducts && this.listOfProducts.topickproducts && this.listOfProducts.topickproducts.length > 0) this.isAllPicked = false
            else this.isAllPicked = true
            this.selectedLocation = ''
            this.selectBatch = ''
            this.pickQty = ''
            this.productInfo = {}
            this.scanCode = ''
            this.productFound = false
            this.focusField('scanFocus')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateProductForPicking (product) {
      this.scanCode = product.number
      this.getRespectiveProductOrder(product)
    },
    getRespectiveProductOrder (material) {
      const materialId = material.id
      this.selectedLocation = ''
      if (this.scanCode) {
        this.productLoading = true
        let list = this.$format.cloneVariable(this.listOfProducts.topickproducts)
        if (list) {
          // to clear values
          this.selectBatch = ''
          this.pickQty = ''
          this.moreLocationsFound = false
          this.batchLocations = []

          let scanedLower = this.scanCode.toLowerCase()
          let getProduct = {}
          if (materialId) {
            getProduct = list.find(x => x.id === materialId)
          } else {
            getProduct = list.find(x => !x.ispackage && ((x.barcode || '').toLowerCase() === scanedLower || (x.productnumber || '').toLowerCase() === scanedLower || (x.productnumberbarcode || '').toLowerCase() === scanedLower))
          }
          if (getProduct) {
            this.productInfo = getProduct
            this.productFound = true
            this.listOfLocations = getProduct.locations || []
            let getStockLocations = getProduct.locations.filter(x => x.availableqty > 0)
            if (this.productInfo.producttype === 'work') {
              setTimeout(() => {
                this.focusField('qtyRef')
              }, 50)
            }
            if (getProduct.isbatch) {
              setTimeout(() => {
                this.focusField('batchRef')
              }, 50)
            } else {
              setTimeout(() => {
                this.focusField('moreLocation')
              }, 50)
            }
            if (getStockLocations.length >= 1) {
              setTimeout(() => {
                this.selectedLocation = getStockLocations[0].locationname
                if (materialId && this.selectedLocation) {
                  const findAvail = material.locations.find(x => x.locationname === this.selectedLocation)
                  if (findAvail && findAvail.availableqty >= material.orderedqty) {
                    // fill in the qty if it has enough stock!
                    this.pickQty = material.orderedqty
                  }
                }
              }, 50)
            } else if (getStockLocations.length > 1) {
              setTimeout(() => {
                this.focusField('moreLocation')
              }, 100)
            }
          } else {
            this.productInfo = {}
            this.productFound = false
            this.listOfLocations = []
            this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noProductFound') })
            this.focusField('scanFocus')
            this.scanCode = ''
          }
        }
        this.productLoading = false
      }
    },
    onResizeHandler () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 40 }
    },
    decreaseQty () {
      if (this.pickQty > 0) this.pickQty--
    },
    increaseQty () {
      if (this.pickQty < 0) this.pickQty = ''
      this.pickQty++
    },
    checkTheBatchnumber () {
      this.pickQty = ''
      this.selectedLocation = ''
      this.moreLocationsFound = false
      this.batchLocations = []
      let products = this.$format.cloneVariable(this.productInfo)
      let batches = []
      if (products && products.locations) {
        this.loadingBatch = true
        let getStock = products.locations
        for (let i = 0; i < getStock.length; i++) {
          let getBatches = getStock[i].batches
          if (getBatches) {
            let getBatchWithStock = getBatches.find(x => x.batchnumber === this.selectBatch)
            if (getBatchWithStock) {
              getBatchWithStock.locationid = getStock[i].locationid
              getBatchWithStock.locationname = getStock[i].locationname
              batches.push(getBatchWithStock)
            }
          }
        }
        if (batches && batches.length <= 0) {
          this.selectBatch = ''
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.notValidBatch') })
          setTimeout(() => {
            this.focusField('batchRef')
          })
        }
        if (batches && batches.length > 1) {
          this.batchLocations = batches
          this.moreLocationsFound = true
          this.focusField('moreLocation')
        } else {
          this.moreLocationsFound = false
          if (batches) {
            let getOnStock = batches[0] ? batches[0].onstock : ''
            if (getOnStock > this.productInfo.orderedqty) this.pickQty = this.productInfo.orderedqty
            else this.pickQty = getOnStock
            this.selectedLocation = batches[0] ? batches[0].locationname : ''
            this.focusField('qtyRef')
          }
        }
        this.loadingBatch = false
      }
    },
    pickQtyOnOrder () {
      let pickedQty = this.$format.replaceCommaWithDot(this.pickQty || 0)
      if (this.$refs.pickForm.validate() && pickedQty > 0) {
        this.saveLoading = true
        let locations = this.listOfLocations
        let getOnStock = locations.find(x => x.locationname === this.selectedLocation)
        let warehouseid = 0
        let locationid = 0
        if (getOnStock) {
          locationid = getOnStock.locationid
          warehouseid = getOnStock.warehouseid
        }
        const productObj = this.$format.cloneVariable(this.productInfo)
        productObj.qty = this.$format.replaceCommaWithDot(this.productInfo.orderedqty)
        productObj.pickedqty = pickedQty
        productObj.invoiceqty = pickedQty
        productObj.batchnumber = this.productInfo && this.productInfo.isbatch ? this.selectBatch : null
        productObj.locationid = locationid
        productObj.warehouseid = warehouseid
        productObj.dg = this.dgCalculationFormula(productObj.costprice, productObj.price, productObj.discount)
        let model = [productObj]
        this.$api.execute('post', `ordermaterials/update_materials/${this.productInfo.orderid}?fromPwa=true`, model)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
            this.getMaterialProducts()
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    dgCalculationFormula (price, salesprice, discount) {
      // FORMULA
      // (price - product costprice) / price * 100 => without discount
      // If Discount
      // price * (100 - discount) / 100
      // (result - costprice) / result * 100
      let getDGValue = 0
      getDGValue = price > 0 ? ((salesprice - price) / salesprice) * 100 : 0
      if (discount && discount > 0) {
        let getResult = +salesprice * (100 - discount) / 100
        let dgValue = ((getResult - price) / getResult) * 100
        getDGValue = dgValue
      }
      return (isNaN(getDGValue) ? 0 : (getDGValue || 0))
    },
    checkIfLocationValid () {
      this.loadingLocation = true
      this.pickQty = ''
      let locations = this.listOfLocations
      let getOnStockValue = locations.find(x => x.locationname === this.selectedLocation)
      if (!getOnStockValue) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
        setTimeout(() => {
          this.pickQty = ''
          this.selectedLocation = ''
          this.focusField('moreLocation')
        })
      } else {
        if (this.productInfo.isbatch) {
          let getBatch = getOnStockValue.batches.find(x => x.batchnumber === this.selectBatch)
          if (getBatch) {
            if (getBatch.onstock > this.productInfo.orderedqty) this.pickQty = this.productInfo.orderedqty
            else this.pickQty = getBatch.onstock
          }
        } else {
          if (getOnStockValue.availableqty > this.productInfo.orderedqty) this.pickQty = this.productInfo.orderedqty
          else this.pickQty = getOnStockValue.availableqty
        }
        setTimeout(() => {
          this.focusField('qtyRef')
        })
      }
      this.loadingLocation = false
    },
    focusField (value) {
      requestAnimationFrame(() => {
        if (this.$refs[value]) {
          setTimeout(() => {
            this.$refs[value].focus()
          })
        }
      })
    },
    clearPickedQty () {
      this.pickQty = ''
    }
  }
}
</script>
